const subscriptionRatingsLabels = {
  rsr: 'Restricted Subscription Ratings',
  psr: 'Private Subscription Ratings',
  'on-demand': 'On-Demand Subscription Ratings',
};

export const getSubscriptionRatingsLabel = (type: string) =>
  subscriptionRatingsLabels[type] || subscriptionRatingsLabels.rsr;

const subscriptionRatingsKeys = {
  rsr: 'restricted',
  psr: 'private',
  'on-demand': 'on-demand',
};

export const getSubscriptionRatingsKey = (type: string) =>
  subscriptionRatingsKeys[type] || subscriptionRatingsKeys.rsr;

const subscriptionRatingsTypes = {
  RESTRICTED_SUBSCRIPTION: 'rsr',
  PRIVATE: 'psr',
  ON_DEMAND_OPEN_SUBSCRIPTION: 'on-demand',
};

export const getSubscriptionRatingsType = (type: string) =>
  subscriptionRatingsTypes[type] || subscriptionRatingsTypes.RESTRICTED_SUBSCRIPTION;
